module.exports = __webpack_public_path__ + "img/CALIFICACION.f8c4edb7.jpg";